import { render, staticRenderFns } from "./AutoStats.vue?vue&type=template&id=974fbe64"
import script from "./AutoStats.vue?vue&type=script&lang=ts"
export * from "./AutoStats.vue?vue&type=script&lang=ts"
import style0 from "./AutoStats.vue?vue&type=style&index=0&id=974fbe64&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports